<template>
  <div>
    <b-card class="md-3">

    
            <!-- Titulo de la seccion-->
            <b-row>
                <b-col class="align-left">
                    <p>
                    <span>Logs del sistema</span>
                    <span style="float:right;padding-right:20px;">
                      <b-button pill variant="outline-danger" @click="cleanLogs">
                      <i class="far fa-trash-alt"></i>
                      <span style="font-size:13px;padding-left:10px;">Limpiar historial logs</span>
                      </b-button>
                    </span>                   
                    </p>
                    <hr style="opacity:0.1 !important;">
                </b-col>
            </b-row>

             <!-- Tabla con la lista de dispositivos-->
                <b-card-text class="userTable">
                    <b-form-textarea
                        id="textarea-rows"
                        rows="8"
                        readonly
                        v-model="textLog"
                    ></b-form-textarea>
              </b-card-text>

    </b-card>
  </div>
</template>


<script>
//BORRAR
import BitacoraService from "@/services/BitacoraService";

export default {
  name: "log-list",
  data(){
    return {
        textLog: '',
        datos: []
    };
  },
    methods: {
        retrieveLogs() {
          BitacoraService.getAll()
            .then(response => {
              this.datos = response.data;
              //Bucle para populacion del texto
              this.populateTextatea()
            })
            .catch(e => {
              console.log(e);
            });
        },

        populateTextatea(){
          var newData = ''
            for (let i = 0; i < this.datos.length; i++) {
                 newData = newData + this.$moment(String(this.datos[i].createdAt)).format('DD/MM/YYYY HH:mm:ss') +'  ::  ' + this.datos[i].level + '   ::   ' + this.datos[i].message + "\n";
             }
          //Populate it
          this.textLog = newData;
        },

        cleanLogs(){
           BitacoraService.deleteAll()
            .then(response => {
              this.datos = [];
              this.populateTextatea()
            })
            .catch(e => {
              console.log(e);
            });   
        }
    },

    mounted() {
      this.retrieveLogs()
    },
}
</script>

<style>
#b-card-title{
  font-size:14px !important;
  font-weight: bold;
  color: #72777a;
}

textarea{
  font-size:13px !important;
}
</style>
